/**
 *  *************************************************************
 *  ****************  大模型数据 Model定义   **********************
 *  *************************************************************
 */
import {
  docBigModelEffects,
  docBigModelReducers,
} from './docBigModel.operator';
// *** 类型定义相关 ***
import { iDocBigModelDataMap } from './docBigModel.type';

/** docBigModelModel 默认状态数据 */
export const docBigModelInitData: iDocBigModelDataMap = {};

/** 大模型Model */
export const docBigModelModel = {
  state: docBigModelInitData,
  reducers: docBigModelReducers,
  effects: docBigModelEffects,
};
